// Funkce pro práci s clipboard

import { FlashMessage } from '@components';
import * as Sentry from '@sentry/browser';

interface CopyToClipboardProps {
  text: string;
  alert?: boolean;
}

const SUCCESS_MESSAGE = 'Odkaz byl zkopírován.';
const ERROR_MESSAGE = 'Odkaz se nepovedlo zkopírovat.';

export const copyToClipboard = async ({ text, alert = true }: CopyToClipboardProps) => {
  if (navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(text);
      if (alert) await FlashMessage({ msg: SUCCESS_MESSAGE, type: 'success' });
    } catch (err) {
      if (alert) await FlashMessage({ msg: ERROR_MESSAGE, type: 'error' });
      Sentry.captureException(err);
    }
  } else {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'absolute';
    textArea.style.left = '-999999px';

    document.body.prepend(textArea);
    textArea.select();

    const commandSuccessful = document.execCommand('copy');

    textArea.remove();

    if (!commandSuccessful) {
      if (alert) await FlashMessage({ msg: ERROR_MESSAGE, type: 'error' });
      return;
    }

    if (alert) await FlashMessage({ msg: SUCCESS_MESSAGE, type: 'success' });
  }
};

// TODO: přidat fci na čtení ze schránky readFromClipboard()
